"use client";
import * as React from "react";
import { Card, Text } from "@hubble/web";
import { Colors } from "themes/color-palette";
import { getRiskSummaryData } from "./riskSummaryData";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import get from "lodash/get";
import type { CoinDetailType } from "types/prices";
import { getCoinType } from "utils/coins";

type AssetRiskSummaryProps = {
  currentCoinDetail: CoinDetailType;
};

type CategoryKey =
  | "memecoinUK"
  | "stablecoinUK"
  | "paxGoldUK"
  | "wrappedcoinUK"
  | "memecoinMiCA"
  | "stablecoinMiCA"
  | "paxGoldMiCA"
  | "wrappedcoinMiCA";

const AssetRiskSummary = ({ currentCoinDetail }: AssetRiskSummaryProps) => {
  const { isUK, isEU } = useCountryStateCookies();
  const t = useTranslations(FILES.PRICES);

  const coinType = getCoinType(currentCoinDetail);
  const isStableCoin = get(currentCoinDetail, "isStableCoin");
  const isMemeCoin = get(currentCoinDetail, "isMemeCoin");
  const isWrappedCoin = get(currentCoinDetail, "isWrappedCoin");
  const isAssetRiskSummaryRequired =
    isStableCoin || isMemeCoin || isWrappedCoin;

  if ((!isUK && !isEU) || !isAssetRiskSummaryRequired || coinType == null) {
    return null;
  }

  const categoryKey: CategoryKey = isUK ? `${coinType}UK` : `${coinType}MiCA`;
  const riskSummaryData = getRiskSummaryData(t)[categoryKey];
  return (
    <Card customBgColor={Colors.blue[50]} mt={4} mb={4} variant="filled">
      <Text.Heading marketing size="xxs" color={Colors.blue[500]} mb={1}>
        {riskSummaryData.title}
      </Text.Heading>
      {riskSummaryData.description.map((description) => (
        <Text.Body
          size="sm"
          marketing
          color={Colors.blue[500]}
          mb={1}
          key={description.key}
        >
          {description.value}
        </Text.Body>
      ))}
    </Card>
  );
};

export default AssetRiskSummary;
